import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MeetingsStatisticsAPI from '../../../api/MeetingsStatisticsAPI';
type Props = { timeRange: { start: string; end: string } };

function UpcomingVisitsCard({ timeRange }: Props) {
  const { t } = useTranslation();
  const [count, setCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await MeetingsStatisticsAPI.getUpcomingVisits({ startTime: timeRange.start, endTime: timeRange.end });
        setCount(res.data?.count ?? 0);
      } catch {
        setCount(0);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end]);

  return (
    <div className="space-y-1">
      <p className="text-2xl font-bold text-foreground">{count}</p>
      <p className="text-sm text-muted-foreground">{t('stats.upcoming_visits') || 'Upcoming visits'}</p>
    </div>
  );
}

export default UpcomingVisitsCard;
